import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

/**
 * Service to convert relative media URLs to absolute URLs pointing to the Booking microservice
 */
@Injectable({
  providedIn: 'root'
})
export class BookingMediaUrlService {
  // URL base del microservicio de Booking
  private readonly bookingApiBaseUrl: string;

  constructor() {
    // Extraer la URL base del microservicio de booking desde environment
    // Si la URL es http://localhost:5000/api/booking, queremos http://localhost:5010
    this.bookingApiBaseUrl = this.getBookingMicroserviceUrl();
  }

  /**
   * Convierte una URL relativa del media en una URL absoluta del microservicio de booking
   * @param relativeUrl URL relativa como /uploads/booking/...
   * @returns URL absoluta como http://localhost:5010/uploads/booking/...
   */
  getAbsoluteMediaUrl(relativeUrl: string | undefined | null): string | null {
    if (!relativeUrl) {
      return null;
    }

    // Si ya es una URL absoluta, devolverla tal cual
    if (relativeUrl.startsWith('http://') || relativeUrl.startsWith('https://')) {
      return relativeUrl;
    }

    // Asegurarse de que la ruta comience con /
    const path = relativeUrl.startsWith('/') ? relativeUrl : `/${relativeUrl}`;

    return `${this.bookingApiBaseUrl}${path}`;
  }

  /**
   * Extrae la URL base del microservicio de booking desde la configuración
   */
  private getBookingMicroserviceUrl(): string {
    // En desarrollo: http://localhost:5010
    // En producción: https://apidevbooking.handly.es o https://apibooking.handly.es
    
    // Detectar el entorno basado en la URL de la API
    const apiUrl = environment.apiUrl || '';
    
    if (apiUrl.includes('localhost')) {
      // Desarrollo local
      return 'http://localhost:5010';
    } else if (apiUrl.includes('devapi') || apiUrl.includes('dev-api')) {
      // Entorno de desarrollo
      return 'https://apidevbooking.handly.es';
    } else {
      // Producción
      return 'https://apibooking.handly.es';
    }
  }
}
